import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="max-w-md w-full">
        <CardContent className="p-8">
          {done ? (
            <div className="text-center">
              <div className="w-14 h-14 rounded-full bg-green-100 text-green-700 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-7 h-7" />
              </div>
              <h2 className="heading text-2xl font-bold text-slate-900">Request submitted</h2>
              <p className="text-slate-600 mt-2">
                If an account exists for <span className="font-medium">{email}</span>, your administrator has been notified and will issue a temporary password.
              </p>
              <Link to="/login" className="inline-block mt-6 text-orange-700 font-medium hover:underline" data-testid="back-login-link">
                Back to login
              </Link>
            </div>
          ) : (
            <>
              <h2 className="heading text-2xl font-bold text-slate-900">Forgot password</h2>
              <p className="text-slate-500 mt-1 text-sm">Enter your email and your administrator will issue a temporary password.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
                </div>
                {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}
                <Button type="submit" disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="forgot-submit-button">
                  {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null} Request reset
                </Button>
                <div className="text-center text-sm">
                  <Link to="/login" className="text-slate-600 hover:text-orange-700">Back to login</Link>
                </div>
              </form>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
